import styled from 'styled-components'

export const BannerIntroContainer = styled.section`
  padding: 5rem var(--paddingD);
  background: url(${props => props.bg}) no-repeat right center;

  h1 {
    color: var(--blue6);
    font-size: 46px;
    font-weight: 800;
  }

  p {
    color: var(--grey2);
    font-size: 20px;
    margin-bottom: 1.5rem;
  }

  div {
    &.svg-container {
      background: var(--light2);
      z-index: -1;
    }

    &.text-container {
      max-width: 60%;

      & > *:not(:last-child) {
        margin-bottom: 2rem;
      }
    }

    &.img-container {
      display: none;
    }
  }

  path {
    vector-effect: non-scaling-stroke;
    fill: none;
    stroke: var(--orange2);
    stroke-width: 2;
    opacity: 0.5;
  }

  @media only screen and (max-width: 900px) {
    background: var(--light2);
    text-align: center;
    padding: 3rem var(--paddingD);

    h1 {
      font-size: 30px !important;
      font-weight: 700;
    }

    p {
      font-size: 14px !important;
      margin-bottom: 1.5rem;
    }

    div {
      &.svg-container {
        display: none;
      }

      &.text-container {
        max-width: 100%;
        margin-bottom: 5rem;

        & > .btn {
          margin-left: auto;
          margin-right: auto;
        }
      }

      &.img-container {
        display: block;

        & > img {
          width: 100%;
        }
      }
    }
  }
`
